define.alias("shared/components/shared/pinterest-business", "settings/components/shared/pinterest-business");